import WbHttpClient from './wbhttpclient';

export default class SearchServices {
  constructor() {
    this.WbHttpClient = new WbHttpClient();
  }

  globalSearch(params = {}) {
    return this.WbHttpClient.get('search/globalSearch', params);
  }

  searchTag(params = {}) {
    return this.WbHttpClient.get('search/searchTag', params);
  }

}
